import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, GitMerge, Loader2, Trash2, X } from "lucide-react";
import { api, errMsg, eur } from "@/lib/api";
import { Field, inp } from "@/components/admin/AdminUi";
import { PTYPE } from "./whApi";

function MergePick({ onPick }) {
  const [q, setQ] = useState("");
  const [opts, setOpts] = useState([]);
  useEffect(() => { if (q.length < 2) return setOpts([]); const t = setTimeout(() => api.get("/admin/compat/models", { params: { q, limit: 10 } }).then((r) => setOpts(r.data)).catch(() => {}), 150); return () => clearTimeout(t); }, [q]);
  return (
    <div className="space-y-1">
      <input data-testid="pending-merge-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Unisci come alias di… (cerca modello)" className={inp} />
      {opts.map((o) => <button key={o.id} data-testid={`pending-merge-opt-${o.id}`} onClick={() => onPick(o)} className="block w-full text-left px-2 py-1 text-sm rounded hover:bg-slate-100">{o.label}</button>)}
    </div>
  );
}

export function PendingDetail({ id, store, readOnly, onClose, onDone }) {
  const [d, setD] = useState(null);
  const [f, setF] = useState(null);
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setD(null);
    api.get(`/admin/printers/${id}`, { params: { store } }).then((r) => {
      setD(r.data); setF({ brand: r.data.brand, model: r.data.model, aliases: r.data.aliases.join(", ") });
      setRows(r.data.items.map((x) => ({ ...x, price: x.proposed, add: false })));
    }).catch((e) => toast.error(errMsg(e)));
  }, [id, store]);
  const act = async (fn, msg) => { setBusy(true); try { await fn(); toast.success(msg); onDone(); } catch (e) { toast.error(errMsg(e)); } setBusy(false); };
  const saveData = () => api.put(`/admin/printers/${id}`, { brand: f.brand, model: f.model, aliases: f.aliases.split(",").map((x) => x.trim()).filter(Boolean), notes: d.notes || "" });
  const approve = () => act(async () => { await saveData(); await api.post(`/admin/printers/${id}/approve`, { store, items: rows.map((r) => ({ code: r.code, price: +String(r.price).replace(",", ".") || 0, add: r.add && !r.in_stock })) }); }, "Stampante approvata");
  const merge = (t) => act(() => api.post(`/admin/printers/${id}/merge`, { target_id: t.id }), `Unita come alias di ${t.label}`);
  const discard = () => act(() => api.post(`/admin/printers/${id}/discard`), "Stampante scartata");
  if (!d || !f) return <aside className="rounded-xl border bg-white p-6"><Loader2 className="w-5 h-5 animate-spin" /></aside>;
  const upd = (i, p) => setRows((l) => l.map((x, j) => (j === i ? { ...x, ...p } : x)));
  return (
    <aside className="rounded-xl border-2 border-brand-navy bg-white p-4 space-y-4 lg:sticky lg:top-[110px] max-h-[85vh] overflow-y-auto" data-testid="pending-detail">
      <div className="flex items-start justify-between"><div className="font-extrabold text-xl" data-testid="pending-detail-label">{d.label}</div>
        <button data-testid="pending-detail-close" onClick={onClose} className="press h-8 w-8 grid place-items-center rounded hover:bg-slate-100"><X className="w-4 h-4" /></button></div>
      {d.duplicate && (
        <div className="rounded-lg border-2 border-amber-400 bg-amber-50 p-3 text-sm flex items-center gap-2" data-testid="pending-dup-alert">
          <span className="flex-1">Possibile variante di <b>{d.duplicate.label}</b></span>
          {!readOnly && <button data-testid="pending-dup-merge" disabled={busy} onClick={() => merge(d.duplicate)} className="press h-8 px-3 rounded bg-amber-500 text-white text-xs font-bold flex items-center gap-1"><GitMerge className="w-3.5 h-3.5" /> Unisci come alias</button>}
        </div>
      )}
      <div className="grid grid-cols-2 gap-2">
        <Field label="Marca"><input data-testid="pending-brand" value={f.brand} onChange={(e) => setF({ ...f, brand: e.target.value })} className={inp} /></Field>
        <Field label="Modello"><input data-testid="pending-model" value={f.model} onChange={(e) => setF({ ...f, model: e.target.value })} className={inp} /></Field>
        <Field label="Alias (separati da virgola)" wide><input data-testid="pending-aliases" value={f.aliases} onChange={(e) => setF({ ...f, aliases: e.target.value })} className={inp} /></Field>
      </div>
      <div>
        <div className="text-xs font-mono uppercase text-slate-500 mb-1">Cartucce collegate ({rows.length})</div>
        <div className="divide-y text-[13px]">
          {rows.map((r, i) => (
            <div key={r.code} className="py-2 flex items-center gap-2" data-testid={`pending-item-${r.code}`}>
              <input type="checkbox" data-testid={`pending-item-add-${r.code}`} disabled={r.in_stock} checked={r.in_stock || r.add} onChange={(e) => upd(i, { add: e.target.checked })} title="Aggiungi a magazzino" />
              <div className="min-w-0 flex-1"><div className="font-mono font-extrabold">{r.code}</div><div className="text-xs text-slate-500 truncate">{PTYPE[r.ptype]} · costo {eur(r.cost)}{r.suggested ? ` · consigliato ${eur(r.suggested)}` : ""}{r.in_stock ? " · già a magazzino" : ""}</div></div>
              <input data-testid={`pending-item-price-${r.code}`} value={r.price} onChange={(e) => upd(i, { price: e.target.value })} className="h-8 w-20 px-2 rounded border text-right" />
            </div>
          ))}
        </div>
      </div>
      {!readOnly && <MergePick onPick={merge} />}
      {!readOnly && (
        <div className="flex gap-2">
          <button data-testid="pending-approve-btn" disabled={busy} onClick={approve} className="press flex-1 h-11 rounded-md bg-brand-yellow text-brand-navy font-bold flex items-center justify-center gap-1.5"><Check className="w-4 h-4" /> Approva</button>
          <button data-testid="pending-discard-btn" disabled={busy} onClick={discard} className="press h-11 px-4 rounded-md border border-rose-300 text-rose-700 font-semibold flex items-center gap-1.5"><Trash2 className="w-4 h-4" /> Scarta</button>
        </div>
      )}
    </aside>
  );
}
